// extracted by mini-css-extract-plugin
export default {"left-space":"g__left-space--COU28","link-button-override":"g__link-button-override--g03SK"};